// extracted by mini-css-extract-plugin
export default {"terms":"TermsCheckbox_terms__kuvLm","label":"TermsCheckbox_label__OA4Tv"};